















































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";

@Component({ components: {} })
export default class AppPunchInOutLayout extends Vue {
  constructor() {
    super();
  }

  onCloseErrorDialog() {
    this.appEnv.isErrorDialogVisible = false;
    this.appEnv.errorDialogMsgs = [];
  }

  get appEnv() {
    return store.state.appEnv;
  }
}
